import { QRCodeSVG } from "qrcode.react";
import { Spin } from "common/elements";
import { btnDelay, usePlaySound } from "common/utils";
import parentI18n from "features/parent/i18n";
import { useQrLoginDisplay } from "./useQrLoginDisplay";

// アプリ内ログインダイアログの QR ステップ。
// 新端末（未ログイン）が QR とコードを表示し、承認をポーリングする。
// 承認されると useQrLoginDisplay がログインし、AuthProvider がダイアログを閉じる。
export const QrLoginForm = () => {
  const play = usePlaySound();
  const { code, time, expired, error, retry } = useQrLoginDisplay({ enabled: true });

  // 期限切れ後はポーリングが停止するため、ユーザー操作でのみ新しいコードを発行する
  const handleRefresh = () => {
    btnDelay(() => {
      play();
      retry();
    });
  };

  return (
    <div className="flex-col-el items-center w-full gap-4">
      <p className="type-text type-sm text-gray2-100 text-center">
        {parentI18n.t("MSG_QR_LOGIN_DISPLAY_DESC")}
      </p>

      {error ? (
        <p className="type-text type-body text-danger text-center">
          {parentI18n.t("MSG_QR_LOGIN_ISSUE_ERROR")}
        </p>
      ) : code ? (
        <>
          <div className="relative">
            <div
              className={`flex-col-el flex-center bg-white box-border border-solid border-2 border-outline rounded-xl p-4 ${
                expired ? "opacity-30" : ""
              }`}
            >
              <QRCodeSVG size={220} value={`manapzl:login:${code}`} />
            </div>
            {expired && (
              <div className="absolute inset-0 flex items-center justify-center">
                <button
                  type="button"
                  onClick={handleRefresh}
                  className="flex items-center justify-center w-[64px] h-[64px] rounded-full bg-white shadow-md border-none cursor-pointer type-inherit-font"
                >
                  <span className="material-symbols-outlined type-hero text-blue-100">refresh</span>
                </button>
              </div>
            )}
          </div>

          <div className="flex-col-el items-center gap-1">
            <p className="type-text type-sm text-gray2-100">
              {parentI18n.t("MSG_QR_LOGIN_ISSUE_CODE_LABEL")}
            </p>
            <p className="type-text type-title text-textcolor-black tracking-widest">{code}</p>
          </div>

          {expired ? (
            <p className="type-text type-body text-danger">
              {parentI18n.t("MSG_QR_LOGIN_ISSUE_EXPIRED")}
            </p>
          ) : (
            <p className="type-text type-body text-textcolor-black">
              {parentI18n.t("MSG_QR_LOGIN_ISSUE_EXPIRES_IN", { time })}
            </p>
          )}
        </>
      ) : (
        <Spin />
      )}
    </div>
  );
};
